import { t } from 'i18next';

export enum ScanPlatform {
  WINDOWS = 'WINDOWS',
  LINUX = 'LINUX',
}

export const getScanPlatformLabel = (platform: ScanPlatform): string => {
  switch (platform) {
    case ScanPlatform.LINUX:
      return t('scanPlatforms.linux');
    case ScanPlatform.WINDOWS:
      return t('scanPlatforms.windows');
  }
};
